import React from "react";
import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

/**
 * CTA Traffic Bar Chart Component using MUI X Charts
 * Displays CTA traffic/conversions over time
 * @param {Object} props
 * @param {Array} props.values - Array of conversion values
 * @param {Array} props.dates - Array of date labels
 * @returns {import("react").ReactElement}
 */
export default function CtaTrafficBar(props) {
  const { values = [], dates = [] } = props;

  if (!values || values.length === 0) {
    return (
      <Box sx={{ position: "relative" }}>
        <Box sx={{ display: "inline-block", width: 590, height: 140, mb: -2.5 }} />
      </Box>
    );
  }

  return (
    <Box sx={{ position: "relative" }}>
      <Box sx={{ display: "inline-block", width: 590, height: 140, mb: -2.5 }}>
        <BarChart
          xAxis={[
            {
              scaleType: "band",
              data: dates,
              tickLabelStyle: {
                fontSize: 10,
              },
            },
          ]}
          yAxis={[
            {
              disableLine: true,
            },
          ]}
          series={[
            {
              data: values,
              color: "#03a9f4",
              valueFormatter: (value) => `${value?.toLocaleString() || 0} conversions`,
            },
          ]}
          width={590}
          height={132}
          margin={{ top: 10, right: 20, bottom: 30, left: 50 }}
          hideLegend
        />
      </Box>
    </Box>
  );
}
